{
  "app.name": "Cargofollow Sign",
  "app.tagline": "Ondertekenen en inzien van vrachtbrieven op je telefoon.",
  "language.label": "Taal",
  "language.nl": "Nederlands",
  "language.en": "Engels",
  "language.de": "Duits",
  "language.fr": "Frans",
  "home.title": "Cargofollow Sign",
  "home.body": "Deze app open je via de link of QR-code die je van de afzender of vervoerder hebt gekregen. Zonder link is er niets te tonen.",
  "route.sign.title": "Ondertekenen",
  "route.sign.body": "De ondertekenflow voor deze link wordt hier geladen.",
  "route.inspect.title": "Inspectie",
  "route.inspect.body": "De vrachtbrief bij deze inspectielink wordt hier getoond.",
  "route.driver.title": "Chauffeur",
  "route.driver.body": "Het overzicht van je ritten wordt hier getoond.",
  "offline.body": "Je bent offline. Wat je ziet komt uit het geheugen van deze app.",
  "error.title": "Er ging iets mis",
  "error.body": "Probeer het opnieuw. Blijft het misgaan, vraag dan een nieuwe link aan.",
  "error.not_found.title": "Pagina niet gevonden",
  "error.not_found.body": "Controleer de link of QR-code die je hebt gekregen.",
  "error.network": "Geen verbinding met de server.",
  "error.unexpected": "Onverwachte fout.",
  "loading": "Bezig met laden",
  "button.sign": "Ondertekenen",
  "button.clear": "Wissen",
  "button.undo": "Ongedaan maken",
  "button.confirm": "Bevestigen",
  "button.cancel": "Annuleren",
  "button.retry": "Opnieuw proberen",
  "button.open": "Openen",
  "button.view_pdf": "PDF bekijken",
  "status.expired.title": "Link verlopen",
  "status.expired.body": "Deze ondertekenlink is verlopen. Vraag de afzender om een nieuwe link.",
  "status.used.title": "Al ondertekend",
  "status.used.body": "Deze link is al gebruikt. Er is niets meer te doen.",
  "status.revoked.title": "Link ingetrokken",
  "status.revoked.body": "De partij die deze link stuurde heeft hem ingetrokken. Vraag om een nieuwe link.",
  "status.success.title": "Ondertekend",
  "status.success.body": "Bedankt, {name}. Je handtekening is vastgelegd op {timestamp}.",
  "shipment.title": "Vrachtbrief",
  "shipment.reference": "Referentie",
  "shipment.consignor": "Afzender",
  "shipment.consignee": "Geadresseerde",
  "shipment.carrier": "Vervoerder",
  "shipment.pickup": "Laadadres",
  "shipment.delivery": "Losadres",
  "shipment.window": "Tijdvak",
  "shipment.goods": "Goederen",
  "shipment.goods.none": "Nog geen goederen opgegeven.",
  "shipment.transport": "Transport",
  "shipment.vehicle": "Kenteken",
  "shipment.driver": "Chauffeur",
  "shipment.transport_type": "Soort vervoer",
  "shipment.charges": "Kosten",
  "shipment.charges.carriage": "Vrachtprijs",
  "shipment.special_agreements": "Bijzondere afspraken",
  "shipment.status.draft": "Concept",
  "shipment.status.issued": "Uitgegeven",
  "shipment.status.in_transit": "Onderweg",
  "shipment.status.delivered": "Afgeleverd",
  "shipment.status.completed": "Afgerond",
  "shipment.status.cancelled": "Geannuleerd",
  "shipment.transport_type.national": "Binnenlands",
  "shipment.transport_type.international": "Internationaal",
  "shipment.transport_type.cabotage": "Cabotage",
  "shipment.transport_type.combined": "Gecombineerd",
  "package_type.pallet": "pallets",
  "package_type.box": "dozen",
  "package_type.carton": "kartons",
  "package_type.crate": "kratten",
  "package_type.bag": "zakken",
  "package_type.drum": "vaten",
  "package_type.roll": "rollen",
  "package_type.bundle": "bundels",
  "package_type.container": "containers",
  "package_type.loose": "los gestort",
  "package_type.other": "colli",
  "document.kind.ecmr_pdf": "Vrachtbrief",
  "document.kind.pod_pdf": "Afleverbewijs",
  "document.kind.attachment": "Bijlage",
  "document.kind.signature_image": "Handtekening",
  "document.kind.photo": "Foto",
  "document.kind.other": "Document",
  "documents.empty.title": "Geen documenten",
  "documents.empty.body": "Zodra er een vrachtbrief of bijlage klaarstaat, verschijnt die hier.",
  "timeline.empty.title": "Nog geen gebeurtenissen",
  "timeline.empty.body": "De geschiedenis van deze zending vult zich zodra er iets gebeurt.",
  "event.shipment.created": "Zending aangemaakt",
  "event.shipment.issued": "Vrachtbrief uitgegeven",
  "event.shipment.updated": "Zending gewijzigd",
  "event.shipment.cancelled": "Zending geannuleerd",
  "event.shipment.pickup_signed": "Afgetekend bij laden",
  "event.shipment.delivered": "Afgeleverd",
  "event.shipment.completed": "Zending afgesloten",
  "event.signature.completed": "Handtekening gezet",
  "event.document.created": "Document toegevoegd",
  "event.remark.added": "Opmerking toegevoegd",
  "event.inspection.viewed": "Inspectie bekeken",
  "event.provider.sync_failed": "Synchronisatie mislukt",
  "event.efti.uil_issued": "eFTI-UIL uitgegeven",
  "event.efti.authority_access": "Opgevraagd door autoriteit",
  "event.efti.combined_transport_stamped": "Stempel gecombineerd vervoer",
  "actor.api_key": "API-sleutel",
  "actor.user": "Gebruiker",
  "actor.signer": "Ondertekenaar",
  "actor.provider": "Platform",
  "actor.system": "Systeem",
  "actor.public": "Openbare link",
  "actor.authority": "Autoriteit",
  "signature.hint": "Zet je handtekening in het vak.",
  "signature.ready": "Handtekening gezet.",
  "sign.role.consignor": "Afzender",
  "sign.role.carrier": "Vervoerder",
  "sign.role.consignee": "Geadresseerde",
  "sign.intro": "Je tekent deze vrachtbrief als {role}.",
  "sign.expires": "Deze link is geldig tot {timestamp}.",
  "sign.documents.title": "Documenten",
  "sign.signatures.title": "Al ondertekend",
  "sign.signatures.none": "Nog niemand heeft getekend.",
  "sign.signatures.entry": "{name} · {timestamp}",
  "sign.start": "Verder naar ondertekenen",
  "sign.step.title": "Je handtekening",
  "sign.field.name": "Naam",
  "sign.field.name.error": "Vul je naam in.",
  "sign.field.company": "Bedrijf",
  "sign.field.company.hint": "Optioneel.",
  "sign.field.signature": "Handtekening",
  "sign.field.signature.error": "Zet eerst je handtekening in het vak.",
  "sign.signature.too_large": "De handtekening past niet binnen de limiet. Wis hem en teken hem eenvoudiger.",
  "sign.consent.label": "Ik onderteken deze vrachtbrief elektronisch en ga akkoord met de eCMR-voorwaarden.",
  "sign.consent.error": "Ga akkoord voordat je ondertekent.",
  "sign.geo.label": "Deel mijn locatie bij deze handtekening",
  "sign.geo.pending": "Locatie ophalen…",
  "sign.geo.captured": "Locatie vastgelegd.",
  "sign.geo.denied": "Geen locatie beschikbaar. Je kunt gewoon ondertekenen.",
  "sign.submit": "Ondertekenen",
  "sign.submitting": "Bezig met versturen",
  "sign.back": "Terug naar de vrachtbrief",
  "sign.success.signed_as": "Ondertekend als {role}",
  "sign.success.consignee_note": "Het afleverbewijs volgt later. Voor deze link is er niets meer te doen.",
  "sign.success.no_pdf": "Er staat nog geen PDF klaar.",
  "sign.method.title": "Hoe wil je ondertekenen?",
  "sign.method.intro": "Je tekent deze vrachtbrief als {role}. Kies hoe je dat doet.",
  "sign.method.drawn.title": "Tekenen op het scherm",
  "sign.method.drawn.body": "Zet je handtekening met je vinger.",
  "sign.method.click_otp.title": "Bevestigen met code",
  "sign.method.click_otp.body": "Je krijgt een code van zes cijfers en bevestigt met één tik.",
  "sign.otp.title": "Bevestigen met code",
  "sign.otp.intro": "Vul je naam in, ga akkoord, en we sturen je een code van zes cijfers.",
  "sign.otp.channel.label": "Waar mag de code heen?",
  "sign.otp.channel.email": "Per e-mail",
  "sign.otp.channel.sms": "Per sms",
  "sign.otp.send": "Stuur de code",
  "sign.otp.sending": "Code versturen",
  "sign.otp.code.title": "Vul de code in",
  "sign.otp.sent": "We hebben een code gestuurd naar {destination}.",
  "sign.otp.code.label": "Code van zes cijfers",
  "sign.otp.code.hint": "De code is tien minuten geldig.",
  "sign.otp.code.error": "Vul alle zes de cijfers in.",
  "sign.otp.resend": "Stuur een nieuwe code",
  "sign.otp.resend.wait": "Nieuwe code over {seconds} seconden",
  "sign.otp.confirm": "Bevestigen en ondertekenen",
  "sign.otp.confirming": "Bezig met bevestigen",
  "sign.otp.error.invalid": "Deze code klopt niet. Kijk het bericht na en probeer het opnieuw.",
  "sign.otp.error.locked": "Te veel foute codes. Vraag straks een nieuwe code aan.",
  "sign.otp.error.expired": "Deze code is verlopen. Vraag een nieuwe code aan.",
  "sign.otp.error.rate_limited": "Er zijn te veel codes aangevraagd. Wacht even en probeer het opnieuw.",
  "sign.otp.error.send": "De code kon niet verstuurd worden. Probeer het opnieuw of teken op het scherm.",
  "sign.otp.error.unavailable": "Deze link heeft geen e-mailadres of telefoonnummer voor een code. Teken op het scherm.",
  "pickup.title": "Laden en ondertekenen",
  "pickup.intro": "Afzender en vervoerder tekenen deze vrachtbrief samen af bij het laden.",
  "pickup.parties.title": "Handtekeningen",
  "pickup.party.signed": "Getekend door {name} op {timestamp}.",
  "pickup.party.signed_elsewhere": "Getekend op een ander toestel.",
  "pickup.party.signed_name": "Getekend door {name}.",
  "pickup.party.queued": "Getekend door {name}, nog niet verstuurd. Dat gebeurt vanzelf zodra je weer online bent.",
  "pickup.party.queued_stopped": "Getekend door {name}, maar niet verstuurd. Bekijk de wachtrij.",
  "pickup.party.waiting": "Nog niet getekend.",
  "pickup.party.no_link": "Voor deze rol is geen ondertekenlink aangemaakt.",
  "pickup.party.link_used": "Deze ondertekenlink is al gebruikt.",
  "pickup.party.link_expired": "Deze ondertekenlink is verlopen.",
  "pickup.party.link_revoked": "Deze ondertekenlink is ingetrokken.",
  "pickup.action.sign_here": "Hier tekenen",
  "pickup.action.own_device": "Op eigen toestel",
  "pickup.handoff.title": "Op eigen toestel: {role}",
  "pickup.handoff.body": "Laat de ondertekenaar deze QR-code scannen. De link werkt één keer en is tien minuten geldig.",
  "pickup.handoff.qr_alt": "QR-code naar de ondertekenlink",
  "pickup.handoff.open": "Link openen",
  "pickup.handoff.expires": "Geldig tot {timestamp}.",
  "pickup.handoff.waiting": "Wachten op de handtekening…",
  "pickup.handoff.creating": "QR-code maken",
  "pickup.handoff.failed": "De QR-code kon niet worden gemaakt.",
  "pickup.handoff.back": "Terug naar het overzicht",
  "pickup.queued.back": "Terug naar het overzicht",
  "pickup.done.title": "Afgetekend bij het laden",
  "pickup.done.body": "Afzender en vervoerder hebben allebei getekend.",
  "pickup.done.status": "Status van de zending: {status}",
  "pickup.done.signature": "{role}: {name} · {timestamp}",
  "pickup.unusable.title": "Geen ophaalsessie",
  "pickup.unusable.body": "Deze link hoort niet bij het laden. Open de link die je van de afzender of vervoerder hebt gekregen.",
  "delivery.title": "Afleveren",
  "delivery.intro": "Controleer de colli, meld voorbehouden en laat de geadresseerde tekenen.",
  "delivery.step": "Stap {current} van {total}",
  "delivery.back": "Terug",
  "delivery.colli.title": "Colli controleren",
  "delivery.colli.body": "Vul per goederenregel in hoeveel colli je hebt ontvangen.",
  "delivery.colli.expected": "Verwacht: {count} {package_type}",
  "delivery.colli.received": "Ontvangen",
  "delivery.colli.error": "Vul een aantal van 0 of meer in.",
  "delivery.colli.empty": "Op deze vrachtbrief staan geen goederenregels.",
  "delivery.colli.total": "Totaal: {received} van {expected} colli.",
  "delivery.colli.line": "{description}: {received} van {expected} ontvangen.",
  "delivery.colli.match": "De aantallen komen overeen.",
  "delivery.colli.shortage": "Er {count, plural, one {ontbreekt # collo} other {ontbreken # colli}}. Meld dit als voorbehoud.",
  "delivery.colli.surplus": "Er {count, plural, one {is # collo} other {zijn # colli}} te veel. Meld dit als voorbehoud.",
  "delivery.remark.title": "Voorbehouden",
  "delivery.remark.body": "Meld schade, een tekort of vertraging bij deze aflevering.",
  "delivery.remark.required": "De aantallen wijken af, dus leg een voorbehoud vast.",
  "delivery.remark.type": "Soort voorbehoud",
  "delivery.remark.type.damage": "Schade",
  "delivery.remark.type.shortage": "Tekort",
  "delivery.remark.type.delay": "Vertraging",
  "delivery.remark.type.other": "Anders",
  "delivery.remark.text": "Toelichting",
  "delivery.remark.text.hint": "Beschrijf kort wat er aan de hand is.",
  "delivery.remark.text.error": "Beschrijf het voorbehoud.",
  "delivery.remark.photos": "Foto's",
  "delivery.remark.photos.hint": "Maximaal {max} foto's. Grote foto's worden verkleind voordat ze worden verstuurd.",
  "delivery.remark.photos.add": "Foto toevoegen",
  "delivery.remark.photos.full": "Je kunt maximaal {max} foto's meesturen.",
  "delivery.remark.photo.alt": "Foto {number}",
  "delivery.remark.photo.compressing": "Verkleinen…",
  "delivery.remark.photo.uploading": "Versturen… {percent}%",
  "delivery.remark.photo.stored": "Verstuurd · {size}",
  "delivery.remark.photo.failed": "Versturen mislukt.",
  "delivery.remark.photo.unreadable": "Deze foto kan niet worden gelezen.",
  "delivery.remark.photo.retry": "Opnieuw versturen",
  "delivery.remark.photo.remove": "Verwijderen",
  "delivery.remark.photo.waiting": "Wacht tot de foto's zijn verstuurd.",
  "delivery.remark.submit": "Voorbehoud vastleggen",
  "delivery.remark.submitting": "Bezig met vastleggen",
  "delivery.remark.skip": "Geen voorbehouden",
  "delivery.remark.failed": "Het voorbehoud kon niet worden vastgelegd. Probeer het opnieuw.",
  "delivery.device.title": "Wie tekent waar?",
  "delivery.device.body": "De geadresseerde tekent op jouw toestel, of op een eigen toestel via een QR-code.",
  "delivery.device.driver": "Ontvanger tekent hier",
  "delivery.device.driver.hint": "Op jouw toestel. Dat wordt zo bij de handtekening vastgelegd.",
  "delivery.device.own": "Op eigen toestel",
  "delivery.device.own.hint": "De geadresseerde scant een QR-code en tekent op de eigen telefoon.",
  "delivery.handoff.back": "Terug naar de keuze",
  "delivery.done.title": "Afgeleverd",
  "delivery.done.body": "De vrachtbrief is afgetekend bij de aflevering.",
  "delivery.done.status": "Status van de zending: {status}",
  "delivery.done.signed": "Getekend door {name} op {timestamp}.",
  "delivery.done.signed_elsewhere": "Getekend op het toestel van de geadresseerde.",
  "delivery.done.device.driver": "Getekend op het toestel van de chauffeur.",
  "delivery.done.device.own": "Getekend op het eigen toestel van de geadresseerde.",
  "delivery.pod.title": "Afleverbewijs",
  "delivery.pod.colli": "Colli: {received} van {expected} ontvangen.",
  "delivery.pod.colli.unknown": "Colli: op dit toestel niet geteld.",
  "delivery.pod.remarks.none": "Geen voorbehouden gemeld.",
  "delivery.pod.remark": "{type}: {text}",
  "delivery.pod.remark.untyped": "{type}",
  "delivery.pod.remark.photos": "{count, plural, one {# foto} other {# foto's}}",
  "delivery.pod.download": "Afleverbewijs downloaden",
  "delivery.pod.pdf": "Afleverbewijs (PDF)",
  "delivery.pod.pdf.pending": "De PDF van het afleverbewijs staat nog niet klaar.",
  "fixtures.title": "Componenten",
  "fixtures.shipment": "ShipmentView",
  "fixtures.timeline": "Timeline",
  "fixtures.documents": "DocumentList",
  "fixtures.signature": "SignaturePad",
  "fixtures.signature.export": "Exporteer PNG",
  "fixtures.signature.exported": "PNG van {width}×{height} px, {bytes} bytes.",
  "fixtures.signature.empty": "Nog niets getekend.",
  "shipment.not_provided": "Niet ingevuld",
  "shipment.box": "Vak {number}",
  "shipment.goods.table": "Goederen (vakken 6 tot en met 12)",
  "shipment.driver.hidden": "Contactgegevens van de chauffeur worden niet getoond.",
  "shipment.driver.phone": "Telefoon chauffeur",
  "shipment.signature.method": "Methode",
  "shipment.signature.trust": "Betrouwbaarheidsniveau",
  "shipment.signature.qtsp": "Vertrouwensdienst",
  "shipment.signature.hash": "Versiehash",
  "shipment.signature.verified": "Komt overeen met de huidige versie",
  "shipment.signature.superseded": "Getekend op een eerdere versie",
  "shipment.signature.method.drawn": "Handtekening op scherm",
  "shipment.signature.method.click_otp": "Bevestiging met eenmalige code",
  "shipment.signature.method.api": "Via de API van het systeem",
  "shipment.signature.method.photo_of_paper": "Foto van een papieren handtekening",
  "shipment.signature.trust.platform_auth": "Platformauthenticatie",
  "shipment.signature.trust.ades": "Geavanceerd (AdES)",
  "shipment.signature.trust.qes": "Gekwalificeerd (QES)",
  "inspect.title": "Vrachtbrief",
  "inspect.subtitle": "Alleen-lezen inzage via de QR-code op de vrachtbrief.",
  "inspect.version": "Versie {version}",
  "inspect.viewed_at": "Bekeken op {timestamp}",
  "inspect.expires": "Deze inspectielink is geldig tot {timestamp}.",
  "inspect.integrity.ok.title": "Keten intact",
  "inspect.integrity.ok.body": "{events} gebeurtenissen, ongebroken sinds het aanmaken.",
  "inspect.integrity.broken.title": "Keten gebroken",
  "inspect.integrity.broken.body": "De gebeurtenissen van deze zending komen niet overeen met hun hashketen. Neem contact op met de vervoerder.",
  "inspect.integrity.head_hash": "Kophash",
  "inspect.documents.title": "Documenten",
  "inspect.pdf.download": "Vrachtbrief downloaden (PDF)",
  "inspect.pdf.none": "Er staat nog geen PDF van deze vrachtbrief klaar.",
  "inspect.print": "Afdrukken",
  "inspect.expired.title": "Inspectielink verlopen",
  "inspect.expired.body": "Deze inspectielink is verlopen. Vraag de vervoerder om een actuele QR-code.",
  "inspect.rotated.title": "Inspectielink vervangen",
  "inspect.rotated.body": "Deze inspectielink is vervangen. Scan de QR-code op de huidige vrachtbrief.",
  "inspect.not_found.title": "Onbekende inspectielink",
  "inspect.not_found.body": "Controleer de QR-code op de vrachtbrief.",
  "driver.title": "Inloggen als chauffeur",
  "driver.intro": "Vul het telefoonnummer in dat je planner bij de zending heeft gezet. Je krijgt een code per sms.",
  "driver.country.label": "Land",
  "driver.phone.label": "Telefoonnummer",
  "driver.phone.hint": "Zonder landnummer; wij zetten er {prefix} voor.",
  "driver.error.phone_invalid": "Dit lijkt geen geldig telefoonnummer.",
  "driver.button.send_code": "Stuur me een code",
  "driver.code.title": "Vul de code in",
  "driver.code.body": "We hebben een code van zes cijfers gestuurd naar {phone}.",
  "driver.code.label": "Code",
  "driver.code.hint": "Zes cijfers, tien minuten geldig.",
  "driver.button.verify": "Inloggen",
  "driver.button.change_number": "Ander nummer gebruiken",
  "driver.error.code_invalid": "Deze code klopt niet of is verlopen. Vraag een nieuwe aan.",
  "driver.error.locked": "Te vaak geprobeerd. Wacht een paar minuten en vraag daarna een nieuwe code aan.",
  "driver.error.session_expired": "Je sessie is verlopen. Log opnieuw in.",
  "driver.list.title": "Je ritten",
  "driver.sandbox.title": "Testomgeving",
  "driver.sandbox.body": "Dit nummer staat alleen op oefenzendingen. Wat je hier ziet is geen echte rit.",
  "driver.button.sign_out": "Uitloggen",
  "driver.button.refresh": "Vernieuwen",
  "driver.empty.title": "Niets openstaand",
  "driver.empty.body": "Op dit nummer staat nu geen rit open. Klopt dat niet, vraag je planner dan om je nummer bij de zending te zetten.",
  "driver.action.load": "Laden",
  "driver.action.deliver": "Lossen",
  "driver.reference.none": "Zonder referentie",
  "driver.ordered_by": "In opdracht van {party}",
  "driver.window.none": "Geen tijdvak afgesproken",
  "driver.then.deliver": "Daarna lossen bij {party} in {city}.",
  "driver.then.loaded": "Geladen bij {party} in {city}.",
  "driver.signed_off": "Al afgetekend.",
  "driver.button.open_pickup": "Laden en ondertekenen",
  "driver.button.open_delivery": "Afleveren en laten tekenen",
  "driver.button.navigate": "Navigeer",
  "driver.tour.untitled": "Rit zonder naam",
  "driver.tour.progress": "{done} van {total} stops",
  "driver.tour.loose": "Losse ritten",
  "driver.tour.stop.numbered": "Stop {position} · {action}",
  "driver.tour.stop.done": "Afgetekend",
  "driver.tour.stop.waiting": "Nog niet aan de beurt",
  "driver.tour.stop.closed": "Niet meer open",
  "queue.title": "Wachtrij",
  "queue.body": "Deze inzendingen staan op dit toestel klaar. Ze worden vanzelf verstuurd zodra er weer verbinding is.",
  "queue.badge": "{count} in de wachtrij",
  "queue.empty.title": "Niets in de wachtrij",
  "queue.empty.body": "Alles wat je hebt vastgelegd is verstuurd.",
  "queue.kind.photo": "Foto",
  "queue.kind.remark": "Voorbehoud",
  "queue.kind.signature": "Handtekening",
  "queue.state.pending": "Wacht op verbinding",
  "queue.state.sending": "Wordt verstuurd",
  "queue.state.conflict": "Elders afgehandeld",
  "queue.state.failed": "Niet verstuurd",
  "queue.captured": "Vastgelegd om {timestamp}",
  "queue.hash": "Inhoud-hash {hash}",
  "queue.attempts": "Pogingen: {count}",
  "queue.reason.queue_blocked": "Niet verstuurd: een eerdere inzending van dezelfde rit is blijven steken.",
  "queue.reason.hash_mismatch": "Niet verstuurd: de opgeslagen inhoud komt niet overeen met de hash van het moment van vastleggen.",
  "queue.reason.already_signed": "Deze vrachtbrief is intussen op een ander toestel getekend. Deze inzending is niet meer nodig.",
  "queue.reason.link_expired": "De link is verlopen voordat deze inzending kon worden verstuurd.",
  "queue.reason.network": "De server was niet bereikbaar. Je kunt het opnieuw proberen.",
  "queue.reason.refused": "De server weigerde deze inzending ({code}).",
  "queue.retry": "Opnieuw proberen",
  "queue.discard": "Weggooien",
  "queue.offline": "Geen verbinding. De wachtrij wacht tot je weer online bent.",
  "queue.done.title": "Vastgelegd, nog niet verstuurd",
  "queue.done.body": "Je hebt geen verbinding. Wat je hebt vastgelegd staat veilig op dit toestel en wordt vanzelf verstuurd zodra je weer online bent.",
  "queue.done.status": "Wordt verzonden zodra online",
  "queue.done.open": "Wachtrij bekijken",
  "delivery.remark.photo.queued": "In de wachtrij, wordt verstuurd zodra je online bent",
  "sign.identification.title": "Identificeer je eerst",
  "sign.identification.intro": "Deze vrachtbrief vraagt om {level}. Identificeer je daarvoor bij {provider}; daarna zet je je handtekening zoals gewoonlijk.",
  "sign.identification.why": "De vertrouwensdienst stelt vast wie je bent en ondertekent daarna precies deze versie van de vrachtbrief.",
  "sign.identification.start": "Identificeren bij {provider}",
  "sign.identification.retry": "Opnieuw proberen",
  "sign.identification.waiting": "Bezig met identificeren",
  "sign.identification.waiting.body": "We wachten tot {provider} je identificatie bevestigt. Dit scherm gaat vanzelf verder.",
  "sign.identification.level.ades": "een geavanceerde handtekening (AdES)",
  "sign.identification.level.qes": "een gekwalificeerde handtekening (QES)"
}
